import { render, staticRenderFns } from "./ClaimRecordEdit.vue?vue&type=template&id=554fb4ab"
import script from "./ClaimRecordEdit.vue?vue&type=script&lang=js"
export * from "./ClaimRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports